import { Routes, Route, Navigate } from 'react-router-dom';

// Layouts
import { PublicLayout } from '../components/layout/PublicLayout';
import { AdminLayout } from '../admin/components/AdminLayout';

// Auth
import { ProtectedRoute } from '../modules/auth/ProtectedRoute';

// Public pages
import { HomePage } from '../public/pages/HomePage';
import { AboutPage } from '../public/pages/AboutPage';
import { EventsPage } from '../public/pages/EventsPage';
import { EventDetailPage } from '../public/pages/EventDetailPage';
import { RegisterPage } from '../public/pages/RegisterPage';
import { SponsorsPage } from '../public/pages/SponsorsPage';
import { NewsPage } from '../public/pages/NewsPage';
import { ContactPage } from '../public/pages/ContactPage';

// Admin pages
import { AdminLogin } from '../admin/pages/AdminLogin';
import { AdminDashboard } from '../admin/pages/AdminDashboard';
import { ManageEvents } from '../admin/pages/ManageEvents';
import { EditEvent } from '../admin/pages/EditEvent';
import { ManageRegistrations } from '../admin/pages/ManageRegistrations';
import { ManageSponsors } from '../admin/pages/ManageSponsors';
import { ManageNews } from '../admin/pages/ManageNews';
import { SiteSettings } from '../admin/pages/SiteSettings';

export function AppRoutes() {
  return (
    <Routes>
      {/* Public routes */}
      <Route element={<PublicLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/events/:eventSlug" element={<EventDetailPage />} />
        <Route path="/register/:eventSlug" element={<RegisterPage />} />
        <Route path="/sponsors" element={<SponsorsPage />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Route>

      {/* Admin login (unprotected) */}
      <Route path="/admin/login" element={<AdminLogin />} />

      {/* Protected admin routes */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<AdminDashboard />} />
        <Route path="events" element={<ManageEvents />} />
        <Route path="events/new" element={<EditEvent />} />
        <Route path="events/:eventId/edit" element={<EditEvent />} />
        <Route path="registrations" element={<ManageRegistrations />} />
        <Route path="sponsors" element={<ManageSponsors />} />
        <Route path="news" element={<ManageNews />} />
        <Route path="settings" element={<SiteSettings />} />
      </Route>

      {/* Catch-all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
